import { schema } from 'normalizr'

export default [new schema.Entity('providersBans', {}, { idAttribute: 'service_provider_id' })]
